import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Alumno, DatosApp, Padre, SyncDeltas} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiMiscService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** PRIVADO  ***/
  /*** misc ***/

  getStatusAgenda(): Promise<SyncDeltas> {
    const url = `${this.apiUrl}misc/status/agenda`;
    return firstValueFrom(this.http.get<SyncDeltas>(url))
  }
  getDatosApp(): Promise<DatosApp> {
    const url = `${this.apiUrl}misc/datos`;
    return firstValueFrom(this.http.get<DatosApp>(url))
  }
  getTextoLegal(): Promise<string> {
    const url = `${this.apiUrl}misc/texto`;
    return firstValueFrom(this.http.get<string>(url))
  }
  getDatosPrivacidad (id: number): Promise<string> {
    const url = `${this.apiUrl}misc/getDatosPrivacidad/${id}`;
    return firstValueFrom(this.http.get<string>(url))
  }
  cerrarSesiones(): Promise<void> {
    const url = `${this.apiUrl}misc/cerrarsesiones`;
    return firstValueFrom(this.http.get<void>(url))
  }
  updateDatos(datos: DatosApp): Promise<any> {
    const url = `${this.apiUrl}misc/datos`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  getSearchUsuarios(str: string): Promise<[Alumno[], Padre[]]> {
    const url = `${this.apiUrl}misc/usuarios/search`;
    return firstValueFrom(this.http.post<[Alumno[], Padre[]]>(url, {cadena: str}))
  }
  saveLogo(datos: {url: string}): Promise<void> {
    const url = `${this.apiUrl}misc/logo`;
    return firstValueFrom(this.http.post<void>(url, datos))
  }
  certificadoAyto(datos: {id: number, nombre: string, recibos: any, fppo: string, ffinal: string,
    grupo: number, suma: number, fechaEmision: string}): Promise<string> {
    const url = `${this.apiUrl}misc/certificado/ayto`;
    return firstValueFrom(this.http.post<string>(url, datos))
  }
  updateTextoLegal(datos: {texto: string}): Promise<any> {
    const url = `${this.apiUrl}misc/texto`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }

}
